// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file actions/v1/status_badge_configuration.proto (package github.actions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file actions/v1/status_badge_configuration.proto.
 */
export const file_actions_v1_status_badge_configuration: GenFile = /*@__PURE__*/
  fileDesc("CithY3Rpb25zL3YxL3N0YXR1c19iYWRnZV9jb25maWd1cmF0aW9uLnByb3RvEhFnaXRodWIuYWN0aW9ucy52MSKKAQogU3RhdHVzQmFkZ2VDb25maWd1cmF0aW9uUmVzcG9uc2USFQoNd29ya2Zsb3dfbmFtZRgBIAEoCRIRCgliYWRnZV91cmwYAiABKAkSFAoMd29ya2Zsb3dfdXJsGAMgASgJEhYKDmRlZmF1bHRfYnJhbmNoGAQgASgJEg4KBmV2ZW50cxgFIAMoCWIGcHJvdG8z");

/**
 * Response payload for an explicit JSON request to
 * GET /:owner/:repo/actions/workflows/:workflow_filename/badge.
 *
 * @generated from message github.actions.v1.StatusBadgeConfigurationResponse
 */
export type StatusBadgeConfigurationResponse = Message<"github.actions.v1.StatusBadgeConfigurationResponse"> & {
  /**
   * @generated from field: string workflow_name = 1;
   */
  workflowName: string;

  /**
   * @generated from field: string badge_url = 2;
   */
  badgeUrl: string;

  /**
   * @generated from field: string workflow_url = 3;
   */
  workflowUrl: string;

  /**
   * @generated from field: string default_branch = 4;
   */
  defaultBranch: string;

  /**
   * @generated from field: repeated string events = 5;
   */
  events: string[];
};

/**
 * Describes the message github.actions.v1.StatusBadgeConfigurationResponse.
 * Use `create(StatusBadgeConfigurationResponseSchema)` to create a new message.
 */
export const StatusBadgeConfigurationResponseSchema: GenMessage<StatusBadgeConfigurationResponse> = /*@__PURE__*/
  messageDesc(file_actions_v1_status_badge_configuration, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(StatusBadgeConfigurationResponseSchema, "fbbf187d2cef")
